"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShiftProposalInfoAsShiftData = void 0;
const luxon_1 = require("luxon");
const getShiftProposalInfoAsShiftData = ({ shift, proposal, }) => {
    let s = luxon_1.DateTime.fromJSDate(shift.startTime);
    let e = luxon_1.DateTime.fromJSDate(shift.endTime);
    if (proposal?.proposedDate) {
        const [year, month, day] = proposal.proposedDate.split('-');
        s = s.set({
            year: +year,
            month: +month,
            day: +day,
        });
        e = e.set({
            year: +year,
            month: +month,
            day: +day,
        });
    }
    if (proposal?.proposedStartTime) {
        const [hour, minute] = proposal.proposedStartTime.split(':');
        s = s.set({
            hour: +hour,
            minute: +minute,
        });
    }
    if (proposal?.proposedEndTime) {
        const [hour, minute] = proposal.proposedEndTime.split(':');
        e = e.set({
            hour: +hour,
            minute: +minute,
        });
    }
    if (e < s) {
        e = e.plus({ day: 1 });
    }
    return {
        startTime: s.toJSDate(),
        endTime: e.toJSDate(),
        payRate: proposal?.proposedPayRate ?? shift.payRate,
        totalRate: proposal?.proposedTotalRate ?? shift.totalRate,
    };
};
exports.getShiftProposalInfoAsShiftData = getShiftProposalInfoAsShiftData;
//# sourceMappingURL=shift-proposal.js.map